import React, { useEffect, useState } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import PageHeader from "components/headers/PageHeader";
import FooterCard from "components/footers/PageFooter";
import MainFeature1 from "components/other-cards/MainFeature.js";
import KnowStats from "components/other-cards/KnowStats";
import EnquiryCard from "components/home-cards/EnquiryCard";
import ContactCard from "components/other-cards/ContactCard";
import { Link, Element } from 'react-scroll'; // Import for smooth scrolling

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV



const Subheading = tw.span`uppercase tracking-wider text-sm`;

export default () => {
  const [heading, setHeading] = useState('We are a Travel Agency.')
  const [description, setDescription] = useState('Welcome to Traviator Holidays — your gateway to unforgettable travel experiences.')

  const [headingVision, setHeadingVision] = useState('Bring Life to Your Vision With Traviator')
  const [descriptionVision, setDescriptionVision] = useState('"Bring life to your vision with Traviator" encapsulates the idea of turning your travel dreams into reality.')

  const [image, setImage] = useState(null); // no default
  const [imageVision, setImageVision] = useState(null);

  const DEFAULT_IMAGE = "https://images.pexels.com/photos/5405598/pexels-photo-5405598.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2";
  const DEFAULT_IMAGE_VISION = "https://images.pexels.com/photos/3762977/pexels-photo-3762977.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2";
  
  const [address, setAddress] = useState('T-09, Govindpuri, Modinagar, Uttar Pradesh 201201, India')
  const [name, setName] = useState('Omansh Bhardwaj')
  const [mobile, setMobile] = useState('6395977935')
  const [email, setEmail] = useState('contact@traviatorholidays.com')
  const [map, setMap] = useState('https://maps.app.goo.gl/hdnsAFqdzyrHR9oC8')
  const [whatsapp, setWhatsapp] = useState('6395977935')

  useEffect(() => {
    document.body.style.overflow = 'auto'
  });

  useEffect(() => {
    const fetchAboutTextImage = async () => {
      try {
        const response = await fetch(`${API_URL}/web/knowus/about`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();

        if (result.header.resCode === 200 && result.data.length > 0) {
          const aboutData = result.data[0]
          setHeading(aboutData.headingAboutUs)
          setDescription(aboutData.descAboutUs)
          setHeadingVision(aboutData.visionHeadAboutUs)
          setDescriptionVision(aboutData.visionDescAboutUs)
          setAddress(aboutData.addressAboutUs)
          setName(aboutData.contactName)
          setMobile(aboutData.contactMobile)
          setEmail(aboutData.contactEmail)
          setMap(aboutData.addressMap)
          setWhatsapp(aboutData.whatsappNumber)
          setImage(aboutData.imageAboutUs || DEFAULT_IMAGE);
          setImageVision(aboutData.visionImageAboutUs || DEFAULT_IMAGE_VISION);
        }
      } catch (error) {
        console.error('Error fetching text data:', error);
      }
    };

    fetchAboutTextImage();
  }, [])

  return (
    <AnimationRevealPage>
      <PageHeader pageName="Know More About Us" titleName="" />

      {/* Main Feature Section */}
      <Link to="stats" smooth={true} duration={2000}>
        <MainFeature1
          subheading={<Subheading>Who We Are ?</Subheading>}
          heading={heading}
          buttonRounded={true}
          primaryButtonText="Why Choose Traviator ?"
          description={description}
          image={image || DEFAULT_IMAGE}
        />
      </Link>

      {/* Add Link for "Why Choose Traviator" to scroll to Stats Section */}
      <Link to="contact" smooth={true} duration={2000}>
        <MainFeature1
          subheading={<Subheading>Our Vision</Subheading>}
          heading={headingVision}
          buttonRounded={true}
          primaryButtonText="Contact Us"
          image={imageVision || DEFAULT_IMAGE_VISION}
          description={descriptionVision}
          textOnLeft={false}
        />
      </Link>

      {/* Stats Section with ID */}
      <Element name="stats">
        <KnowStats />
      </Element>


      {/* Contact Section with ID */}
      <Element name="contact">
        <ContactCard name={name} mapLink={map} mobile={mobile} email={email} address={address} whatsapp={whatsapp} />
        <EnquiryCard />
      </Element>
      <br /><br />
      <FooterCard />
    </AnimationRevealPage>
  );
};
